export default __webpack_public_path__ + "static/media/launch-co.d1ef314e.png";